import React, {Component} from "react"
import {connect} from "react-redux"
import {bindActionCreators} from "redux";
import {withTranslation} from 'react-i18next'
import Moment from 'moment';

import {logPageView} from '../../../utils/emfLogs'
import {Pages} from '../../../utils/loggerConstants'
import {pageLoadLogs} from '../../../utils/loggerUtils'

import employeeService from "../../../services/Employee.service"
import {actions as employeeActions} from "../../../actions/employee";
import {UserRoles} from "../../../constants";
import {contains} from "../../../utils/jsUtils"

import AwardSection from "./AwardSection"
import AwardViewByDropdown from "./AwardViewByDropdown"
import ActionButton from "./ActionButton"
import CalendarSection from "./CalendarSection"
import {
  AWARD_SUMMARY_OPTIONS,
  AWARD_VIEW_BY_OPTIONS,
  AWARD_VIEW_TO_REPORT_TYPE,
  DETAILED_TAX_INFORMATION_OPTIONS,
  COMPENSATION_YEAR,
  VEST_OR_TAX_OPTIONS
} from './common'
import {DOWNLOAD_TYPE, REPORT_TYPE} from "../common/common";
import FractionalSharesDialog from "../common/dialogs/FractionalSharesDialog"
import VestElectionsDialog from "../common/dialogs/VestElectionsDialog"
import ChangeTaxRateDialog from "../common/dialogs/ChangeTaxRateDialog"

import {Col, View} from '@amzn/stencil-react-components/layout'
import {WithBreakpoints} from '@amzn/stencil-react-components/responsive'
import {PopupDateRangePicker} from '@amzn/stencil-react-components/date-picker'

class StockAwards extends Component {

  constructor(props) {
    super(props);

    this.state = {
      awardViewBySelectedOption: AWARD_VIEW_BY_OPTIONS.AWARD_DATE,
      startDate: this.getDefaultAwardStartDate(props.employee),
      endDate: this.getDefaultAwardEndDate(props.employee),
      fractionalSharesDialogVisible: false,
      taxRateChangeDialogVisible: false,
      vestElectionsDialogVisible: false,
      awardIdSelected: null,
      calendarYear: null,
      vest: null,
      vestElectionPriorId: null,
      taxRatePriorId: null
    };
  }

  componentDidMount() {
    logPageView(Pages.StockAwards)
    pageLoadLogs(navigator.userAgent, Pages.StockAwards)
  }

  getDefaultAwardStartDate = (employee) => {
     return employee.awards === null || employee.awards.length === 0 ? null : Moment(employee.awards[employee.awards.length - 1].awarded_date, 'YYYY-MM-DD').toDate();
  }

  getDefaultAwardEndDate = (employee) => {
     return employee.awards === null || employee.awards.length === 0 ? null : Moment(employee.awards[0].awarded_date, 'YYYY-MM-DD').toDate();
  }

  onAwardViewByDropdownChange = (selectedOption) => {
    if (selectedOption.value === AWARD_VIEW_BY_OPTIONS.AWARD_DATE) {
      this.onChangeDate(this.getDefaultAwardStartDate(this.props.employee), this.getDefaultAwardEndDate(this.props.employee));
    } else if (selectedOption.value === AWARD_VIEW_BY_OPTIONS.CUSTOM) {
      const groups = employeeService.getTransactionsAndVestsByYear(this.props.employee.awards, null, null, false);
      var startDate = null;
      var endDate = null;

      if (groups.completed.length > 0) {
        startDate = groups.completed[0].transaction_date;
        endDate = groups.completed[groups.completed.length - 1].transaction_date;
      }
      if (groups.remaining.length > 0) {
        if (startDate == null) {
          startDate = groups.remaining[0].vest_date;
        }
        endDate = groups.remaining[groups.remaining.length - 1].vest_date;
      }

      this.onChangeDate(startDate, endDate);
    } else if (selectedOption.value === AWARD_VIEW_BY_OPTIONS.OPTION_ACTIVITY) {
      const options = employeeService.getOptions(this.props.employee.awards);
      const optionsStart = options === null || options.length === 0 ? null : Moment(options[options.length - 1].awarded_date, 'YYYY-MM-DD').toDate();
      const optionsEnd = options === null || options.length === 0 ? null : Moment(options[0].awarded_date, 'YYYY-MM-DD').toDate();

      this.onChangeDate(optionsStart, optionsEnd);
    }

    this.setState({
      awardViewBySelectedOption: selectedOption.value
    });
  }

  onAwardSummaryMenuOptionClick = (selectedOption) => {

    const reportType = AWARD_VIEW_TO_REPORT_TYPE.get(this.state.awardViewBySelectedOption);
    let startDate = null;
    let endDate = null;
    let compensationYearStartMonth = null;
    let compensationYearEndMonth = null;
    const downloadType = selectedOption.value === AWARD_SUMMARY_OPTIONS.VIEW_BY_PDF ? DOWNLOAD_TYPE.PDF : DOWNLOAD_TYPE.EXCEL;

    switch (reportType) {
      case REPORT_TYPE.AWARD_SUMMARY_CALENDAR_YEAR:
        break;
      case REPORT_TYPE.AWARD_SUMMARY_COMPENSATION_YEAR:
        compensationYearStartMonth = COMPENSATION_YEAR.START_MONTH;
        compensationYearEndMonth = COMPENSATION_YEAR.END_MONTH;
        break;
      default:
        startDate = this.state.startDate ? Moment(this.state.startDate).format() : null;
        endDate = this.state.endDate ? Moment(this.state.endDate).format() : null;
        break;
    };

    this.props.actions.employee.getSummaryDocument(
      this.props.employee.id,
      reportType,
      startDate,
      endDate,
      downloadType,
      null,
      compensationYearStartMonth,
      compensationYearEndMonth
    );
  }

  onChangePaymentMethodClick = (vest) => {
      this.onVestElectionsActionButtonClick(vest);
  }

  onDetailedTaxInformationMenuOptionClick = (selectedOption) => {

    const currentAwardView = this.state.awardViewBySelectedOption;
    const reportType = this.getReportTypeByDetailedTaxInfoOption(selectedOption.value);
    let filteredRequestedAwardIds = null;
    if (currentAwardView != AWARD_VIEW_BY_OPTIONS.CALENDAR_YEAR && currentAwardView != AWARD_VIEW_BY_OPTIONS.COMPENSATION_YEAR) {
      filteredRequestedAwardIds = [];
      const start = Moment(this.state.startDate);
      const end = Moment(this.state.endDate);
      this.props.employee.awards.forEach((award) =>{
        const awardedDate = Moment(award.awarded_date)
        if (award.transactions && award.transactions.length > 0 && awardedDate.isBetween(start, end,'day', "[]")) {
          filteredRequestedAwardIds.push(award.id)
        }
      });
    }
    this.props.actions.employee.getDetailedTaxDocument(reportType, this.props.employee.id, null, null, filteredRequestedAwardIds);
  }

  onAwardMenuItemClick = (key, awardId, index) => {
    if (key === AWARD_SUMMARY_OPTIONS.VIEW_BY_PDF || key === AWARD_SUMMARY_OPTIONS.DOWNLOAD_EXCEL) {
      const award = employeeService.loadAward(this.props.employee.awards, awardId);
      const isOption = employeeService.isOption(award);
      const downloadType = key === AWARD_SUMMARY_OPTIONS.VIEW_BY_PDF ? DOWNLOAD_TYPE.PDF : DOWNLOAD_TYPE.EXCEL;
      const reportType = isOption ? REPORT_TYPE.AWARD_SUMMARY_OPTION : AWARD_VIEW_TO_REPORT_TYPE.get(this.state.awardViewBySelectedOption);

      this.props.actions.employee.getSummaryDocument(
        this.props.employee.id,
        reportType,
        null,
        null,
        downloadType,
        awardId
      );
    }

    if (this.isDetailedTaxInformationOption(key)) {
      const reportType = this.getReportTypeByDetailedTaxInfoOption(key);
      this.props.actions.employee.getDetailedTaxDocument(
        reportType,
        this.props.employee.id,
        null,
        null,
        awardId);
    }

    if (key === VEST_OR_TAX_OPTIONS.VEST_ELECTION) {
      this.setState({
        awardIdSelected: awardId,
        calendarYear: null,
        vestElectionsDialogVisible: true,
        vest: null,
        vestElectionPriorId: awardId + index
      });
    }

    if (key === VEST_OR_TAX_OPTIONS.US_FED_TAX_RATE) {
      this.setState({
        awardIdSelected: awardId,
        calendarYear: null,
        taxRateChangeDialogVisible: true,
        vest: null
      });
    }
  }

  onCalendarMenuItemClick = (key, year) => {
    if (key === AWARD_SUMMARY_OPTIONS.VIEW_BY_PDF) {
      this.getSummaryDocumentByCalendarMenuOption(DOWNLOAD_TYPE.PDF, year);
    }

    if (key === AWARD_SUMMARY_OPTIONS.DOWNLOAD_EXCEL) {
      this.getSummaryDocumentByCalendarMenuOption(DOWNLOAD_TYPE.EXCEL, year);
    }

    if (this.isDetailedTaxInformationOption(key)) {
      const reportType = this.getReportTypeByDetailedTaxInfoOption(key);
      let startDate;
      let endDate;

      if (this.state.awardViewBySelectedOption === AWARD_VIEW_BY_OPTIONS.COMPENSATION_YEAR) {
        startDate = Moment(new Date(year, 3, 1)).format();
        endDate = Moment(new Date(parseInt(year) + 1, 4, 31)).endOf('day').format();
      } else if (this.state.awardViewBySelectedOption === AWARD_VIEW_BY_OPTIONS.CALENDAR_YEAR) {
        startDate = Moment(new Date(year, 0, 1)).format();
        endDate = Moment(new Date(year, 11, 31)).endOf('day').format();
      } else {
        startDate = this.state.startDate ? Moment(this.state.startDate).format() : null;
        endDate = this.state.endDate ? Moment(this.state.endDate).format() : null;
      }

      this.props.actions.employee.getDetailedTaxDocument(
        reportType,
        this.props.employee.id,
        startDate,
        endDate
      );
    }

    if (key === VEST_OR_TAX_OPTIONS.VEST_ELECTION) {
      this.setState({
        calendarYear: year,
        vestElectionsDialogVisible: true
      });
    }

    if (key === VEST_OR_TAX_OPTIONS.US_FED_TAX_RATE) {
      this.setState({
        awardIdSelected: null,
        calendarYear: year,
        taxRateChangeDialogVisible: true
      });
    }
  }

  onVestElectionsActionButtonClick = (vest) => {
    this.setState({
      awardIdSelected: null,
      calendarYear: null,
      vestElectionsDialogVisible: true,
      vest: vest,
      vestElectionPriorId: this.props.t('StockAwards.VestElectionTitle')
    })
  };

  onVestElectionsDialogClose = () => {
    this.setState({
      vestElectionsDialogVisible: false
    })
  };

  onVestElectionsDialogDeliveryMethodChange = () => {
    this.setState({
      vestElectionsDialogVisible: false,
      fractionalSharesDialogVisible: true
    })
  };


  onFractionalSharesDialogClose = () => {
    this.setState({
      fractionalSharesDialogVisible: false
    });

    document.getElementById(this.state.vestElectionPriorId)?.focus();
  };

  onTaxRateChangeActionButtonClick = (vest, priorId=null) => {
    this.setState({
      awardIdSelected: null,
      calendarYear: null,
      taxRateChangeDialogVisible: true,
      vest: vest,
      taxRatePriorId: priorId
    })
  };

  onChangeDate = (start, end) => {
    const startMoment = Moment(start, 'YYYY-MM-DD');
    const endMoment = Moment(end, 'YYYY-MM-DD');
    this.setState({
      startDate: startMoment.isValid() ? startMoment.toDate() : null,
      endDate: endMoment.isValid() ? endMoment.toDate() : null,
    });
  }

  getDateFormattedToISO = (date) => {
    if (date){
      return date.toISOString().split('T')[0];
    }

    return null;
  }

  getAwardSummaryMenuOptions = (t) => [
    {value: AWARD_SUMMARY_OPTIONS.VIEW_BY_PDF, label: t('StockAwards.AwardSummaryMenu.ViewPDFOption')},
    {value: AWARD_SUMMARY_OPTIONS.DOWNLOAD_EXCEL, label: t('StockAwards.AwardSummaryMenu.DownloadExcelOption')}
  ];

  getDetailedTaxInformationOptions = (t) => [
    {value: DETAILED_TAX_INFORMATION_OPTIONS.VIEW_BY_PDF, label: t('StockAwards.DetailedTaxMenu.ViewPDFOption')},
    {
      value: DETAILED_TAX_INFORMATION_OPTIONS.DOWNLOAD_EXCEL,
      label: t('StockAwards.DetailedTaxMenu.DownloadExcelOption')
    },
    {
      value: DETAILED_TAX_INFORMATION_OPTIONS.VIEW_STATEMENT,
      label: t('StockAwards.DetailedTaxMenu.ViewStatementOption')
    }
  ];

  getReportTypeByDetailedTaxInfoOption(key) {
    if (key === DETAILED_TAX_INFORMATION_OPTIONS.VIEW_BY_PDF) {
      return REPORT_TYPE.DETAIL_TAX_PDF;

    } else if (key === DETAILED_TAX_INFORMATION_OPTIONS.DOWNLOAD_EXCEL) {
      return REPORT_TYPE.DETAIL_TAX_EXCEL

    } else {
      return REPORT_TYPE.EMPLOYEE_EQUITY_PDF;
    }
  }

  getSummaryDocumentByCalendarMenuOption(downloadType, year) {
    const reportType = AWARD_VIEW_TO_REPORT_TYPE.get(this.state.awardViewBySelectedOption);
    this.props.actions.employee.getSummaryDocument(
      this.props.employee.id,
      reportType,
      this.state.startDate ? Moment(this.state.startDate).format() : null,
      this.state.endDate ? Moment(this.state.endDate).format() : null,
      downloadType,
      null,
      this.state.awardViewBySelectedOption === AWARD_VIEW_BY_OPTIONS.COMPENSATION_YEAR ? COMPENSATION_YEAR.START_MONTH : null,
      this.state.awardViewBySelectedOption === AWARD_VIEW_BY_OPTIONS.COMPENSATION_YEAR ? COMPENSATION_YEAR.END_MONTH : null,
      year
    );
  }

  getAwardSections(awards, t) {
    let sections = [];
    const awardsByDate = employeeService.awardsByDate(awards, Moment(this.state.startDate), Moment(this.state.endDate));
    const rsus = employeeService.getRSUs(awardsByDate, false);
    const options = employeeService.getOptions(awardsByDate, false);
    const fullyVestedAwards = employeeService.getFullyVestedAwards(awardsByDate);

    sections.push({
      awards: rsus,
      title: t('StockAwards.ActiveRSUSectionTitle', {number_of_awards: rsus.length}),
      hidden: false
    });

    if (options && options.length > 0) {
      sections.push({
        awards: options,
        title: t('StockAwards.ActiveOptionSectionTitle', {number_of_awards: options.length}),
        hidden: false
      });
    }

    if (fullyVestedAwards && fullyVestedAwards.length > 0) {
      sections.push({
        awards: fullyVestedAwards,
        title: t('StockAwards.FullyVestedSectionTitle', {number_of_awards: fullyVestedAwards.length}),
        hidden: true
      });
    }
    return sections;
  }

  /** "Option" view menu is visible only when the user has options. **/
  getOptionSections(awards, t) {
    let sections = [];
    const awardsByDate = employeeService.awardsByDate(awards, Moment(this.state.startDate), Moment(this.state.endDate));
    const options = employeeService.getOptions(awardsByDate, false);
    const fullyVestedOptions = employeeService.getFullyVestedAwards(awardsByDate, true);

    if (options && options.length > 0) {
      sections.push({
        awards: options,
        title: t('StockAwards.ActiveOptionSectionTitle', {number_of_awards: options.length}),
        hidden: false
      });
    }

    if (fullyVestedOptions && fullyVestedOptions.length > 0) {
      sections.push({
        awards: fullyVestedOptions,
        title: t('StockAwards.FullyVestedSectionTitle', {number_of_awards: fullyVestedOptions.length}),
        hidden: true
      });
    }

    return sections;
  }

  /** Calendar Section applies to RSU only **/
  getCalendarSections(vewByOption, awards) {
    let sections = [];
    let groups = null;
    const rsus = employeeService.getRSUs(awards);

    if (vewByOption === AWARD_VIEW_BY_OPTIONS.CALENDAR_YEAR) {
      groups = employeeService.getTransactionsAndVestsByYear(rsus);
      Object.keys(groups).reverse().forEach((key) => { sections.push(groups[key]) });
    }

    if (vewByOption === AWARD_VIEW_BY_OPTIONS.COMPENSATION_YEAR) {
      groups = employeeService.getTransactionsAndVestsByYear(rsus, null, null, true, COMPENSATION_YEAR.START_MONTH, COMPENSATION_YEAR.END_MONTH);
      Object.keys(groups).reverse().forEach((key) => { sections.push(groups[key]) });
    }

    if (vewByOption === AWARD_VIEW_BY_OPTIONS.CUSTOM) {
      groups = employeeService.getTransactionsAndVestsByYear(rsus, this.state.startDate, this.state.endDate, false);
      sections.push(groups);
    }

    return sections;
  }

  getSections(viewByOption, awards, t) {
    if (viewByOption === AWARD_VIEW_BY_OPTIONS.AWARD_DATE) {
      return this.getAwardSections(awards, t);
    }

    if (contains([
      AWARD_VIEW_BY_OPTIONS.CALENDAR_YEAR,
      AWARD_VIEW_BY_OPTIONS.COMPENSATION_YEAR,
      AWARD_VIEW_BY_OPTIONS.CUSTOM
    ], viewByOption)) {
      return this.getCalendarSections(viewByOption, awards);
    }

    if (viewByOption === AWARD_VIEW_BY_OPTIONS.OPTION_ACTIVITY) {
      return this.getOptionSections(awards, t);
    }

    return [];
  }

  createActionPanel = (t, isTaxHidden) => {
    return (
      <WithBreakpoints>
        {({matches}) => (
          <Col gridGap={matches.s ? "S200" : "S300"} flexDirection={matches.s ? "column" : "row"} flexWrap="wrap">
            <ActionButton
              title={t('StockAwards.AwardSummaryMenu.Title')}
              options={this.getAwardSummaryMenuOptions(t)}
              onMenuOptionClick={this.onAwardSummaryMenuOptionClick}
            />
            <ActionButton
              title={t('StockAwards.DetailedTaxMenu.Title')}
              options={this.getDetailedTaxInformationOptions(t)}
              onMenuOptionClick={this.onDetailedTaxInformationMenuOptionClick}
            />
            {this.props.fractionalMode &&
              <ActionButton
                title={t('StockAwards.VestElectionTitle')}
                onClick={() => this.onVestElectionsActionButtonClick(null)}
              />
            }
            {this.props.fractionalMode && !isTaxHidden &&
              <ActionButton
                title={t('StockAwards.USFedRateTitle')}
                onClick={() => this.onTaxRateChangeActionButtonClick(null, t('StockAwards.USFedRateTitle'))}
              />
            }
          </Col>
        )}
      </WithBreakpoints>
    )
  }

  createAwardDisplayControl = (t) => {
    return (
      <WithBreakpoints>
        {({matches}) => (
          <Col gridGap="S500">
            <AwardViewByDropdown
              selectedOptionValue={this.state.awardViewBySelectedOption}
              onChange={this.onAwardViewByDropdownChange}
              width={matches.s ? "100%" : 300}
            />
            {this.shouldShowCalendar(this.state.awardViewBySelectedOption) &&
              <Col width={matches.s ? "100%" : 616}>
                <PopupDateRangePicker
                  onChange={(start, end) => this.onChangeDate(start, end)}
                  startValue={this.getDateFormattedToISO(this.state.startDate)}
                  endValue={this.getDateFormattedToISO(this.state.endDate)}
                  defaultStartValue={this.getDateFormattedToISO(this.state.startDate)}
                  defaultEndValue={this.getDateFormattedToISO(this.state.endDate)}
                  locale={this.props.locale}
                  startDateLabelText={t('StockAwards.CalendarSection.StartDateLabel')}
                  endDateLabelText={t('StockAwards.CalendarSection.EndDateLabel')}
                  maxYear={this.getMaxCalendarYear(this.props.employee.awards)}
                  calendarButtonAltText={{startDate: "Date from calendar", endDate: "Date to calendar"}}
                  clearButtonAltText={{startDate: "Clear start date", endDate: "Clear end date"}}
                />
              </Col>
            }
          </Col>
          )}
      </WithBreakpoints>
    );
  }

  isAwardSection(viewByOption) {
    return (
      viewByOption === AWARD_VIEW_BY_OPTIONS.AWARD_DATE ||
      viewByOption === AWARD_VIEW_BY_OPTIONS.OPTION_ACTIVITY
    );
  }

  isDetailedTaxInformationOption(option) {
    return contains([
      DETAILED_TAX_INFORMATION_OPTIONS.VIEW_BY_PDF,
      DETAILED_TAX_INFORMATION_OPTIONS.DOWNLOAD_EXCEL,
      DETAILED_TAX_INFORMATION_OPTIONS.VIEW_STATEMENT
    ], option);
  }

  shouldShowCalendar(viewByOption) {
    return (
      viewByOption === AWARD_VIEW_BY_OPTIONS.AWARD_DATE ||
      viewByOption === AWARD_VIEW_BY_OPTIONS.OPTION_ACTIVITY ||
      viewByOption === AWARD_VIEW_BY_OPTIONS.CUSTOM
    );
  }

  getMaxCalendarYear = (awards) => {
    let maxYear = new Date().getFullYear();
    if (awards === null) {
      return maxYear;
    }

    awards.forEach((award) => {
      award.vests.forEach((vest) => {
        let vestYear = Moment(vest.vest_date, 'YYYY-MM-DD').year()
        maxYear = Math.max(maxYear, vestYear)
      })
    });
    return maxYear;
  }

  render() {
    const {t, employee, brokerName} = this.props;
    const isTaxHidden = employeeService.hasRole(employee.roles, UserRoles.OVERRIDE_FED_TAX_HIDE) ? true : false;
    const sections = this.getSections(this.state.awardViewBySelectedOption, employee.awards, t);

    return (
      <View>
        <Col gridGap="S500">
          <Col gridGap="S500" margin={{bottom:10}}>
            {this.createActionPanel(t, isTaxHidden)}
            {this.createAwardDisplayControl(t)}
          </Col>
        </Col>

        <VestElectionsDialog
          visible={this.state.vestElectionsDialogVisible}
          onChangeDeliveryMethodButtonClick={this.onVestElectionsDialogDeliveryMethodChange}
          onDialogClose={this.onVestElectionsDialogClose}
          awardIdSelected={this.state.awardIdSelected}
          vest={this.state.vest}
          calendarYear={this.state.calendarYear}
        />

        <FractionalSharesDialog
          visible={this.state.fractionalSharesDialogVisible}
          onDialogClose={this.onFractionalSharesDialogClose}
          idFrom={this.state.vestElectionPriorId}
        />
        <ChangeTaxRateDialog
          visible={this.state.taxRateChangeDialogVisible}
          onCloseDialog={() => this.setState({taxRateChangeDialogVisible: false})}
          awardIdSelected={this.state.awardIdSelected}
          viewType={this.state.awardViewBySelectedOption}
          calendarYear={this.state.calendarYear}
          idFrom={this.state.taxRatePriorId}
        />

        {this.isAwardSection(this.state.awardViewBySelectedOption) &&
          sections.map((section, index) => {
            return (
              <AwardSection
                awards={section.awards}
                sectionId={index}
                sectionTitle={section.title}
                isTaxHidden={isTaxHidden}
                onAwardMenuItemClick={this.onAwardMenuItemClick}
                onChangePaymentMethodClick={this.onChangePaymentMethodClick}
              />
            )
          })}

        {this.state.awardViewBySelectedOption === AWARD_VIEW_BY_OPTIONS.CALENDAR_YEAR &&
          <CalendarSection
            sections={sections}
            broker={brokerName}
            calendarType={AWARD_VIEW_BY_OPTIONS.CALENDAR_YEAR}
            onCalendarMenuItemClick={this.onCalendarMenuItemClick}
            onChangePaymentMethodClick={this.onChangePaymentMethodClick}
          />
        }

        {this.state.awardViewBySelectedOption === AWARD_VIEW_BY_OPTIONS.COMPENSATION_YEAR &&
          <CalendarSection
            sections={sections}
            broker={brokerName}
            startMonth={COMPENSATION_YEAR.START_MONTH}
            endMonth={COMPENSATION_YEAR.END_MONTH}
            calendarType={AWARD_VIEW_BY_OPTIONS.COMPENSATION_YEAR}
            onCalendarMenuItemClick={this.onCalendarMenuItemClick}
            onChangePaymentMethodClick={this.onChangePaymentMethodClick}
          />
        }

        {this.state.awardViewBySelectedOption === AWARD_VIEW_BY_OPTIONS.CUSTOM &&
          <CalendarSection
            sections={sections}
            broker={brokerName}
            isCustom={true}
            calendarType={AWARD_VIEW_BY_OPTIONS.CUSTOM}
            onChangePaymentMethodClick={this.onChangePaymentMethodClick}
          />
        }
      </View>
    )
  }
}

const mapState = (state) => ({
  employee: state.employee,
  fractionalMode: state.static_content.fractional_mode,
  brokerName: state.employee.broker ? state.employee.broker.name : '',
  locale: state.employee.language
})

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch)
  }
})

export default connect(mapState, mapDispatchToProps)(withTranslation('translationsV2')(StockAwards))
